import { render, staticRenderFns } from "./SpLogin.vue?vue&type=template&id=48a9572a&"
import script from "./SpLogin.vue?vue&type=script&lang=ts&"
export * from "./SpLogin.vue?vue&type=script&lang=ts&"
import style0 from "./SpLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports